import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {bindActionCreators} from "redux";
import {connect, useSelector} from 'react-redux';
import {Container, Grid, Paper, Typography, Box} from '@mui/material';
import MainMenu from "../../core/mainMenu";
import actions from "../../../store/attestation/actions";
import {selectAttestationById} from "../../../store/attestation/selectors";
import {Question, TEST_STATE} from "../../../common/course";
import QuestionComponent from '../../core/task/test/Question';
import SuccessComponent from '../../core/task/test/Success';
import FailComponent from '../../core/task/test/Fail';

type Props = {
    fetchSubmition: Function;
    sensAttestationResults: Function;
}
const View = ({fetchSubmition, sensAttestationResults}: Props) => {
    const {attestationId} = useParams();
    //@ts-expect-error
    const attestation = useSelector(state => selectAttestationById(state, attestationId));
    const [answers, setAnswers] = useState<{id: string, values: Question['options']}[]>([]);
    const [testStatus, setTestStatus] = useState(TEST_STATE.IN_PROGRESS);
    const [isSendingInProgress, setSendingProgress] = useState(false);
    
    useEffect(() => {
        fetchSubmition(attestationId);
    }, []);
    useEffect(() => {
        if (!answers.length) {
            return;
        } 
        if (answers.length === attestation.lastSubmission?.questions.length) {
            sensAttestationResults({attestationId: attestationId, answers});
            setTestStatus(TEST_STATE.CHECKING);
            setSendingProgress(true)
        }
    }, [answers]);

    useEffect(() => {
        if (!isSendingInProgress) {
            return;
        }
        const {lastSubmission} = attestation;
        setTestStatus(lastSubmission.passed ? TEST_STATE.SUCCESS : TEST_STATE.FAIL);
    }, [attestation]);


    if (!attestation?.lastSubmission) {
        return null;
    }

    return (
        <>
            <MainMenu />
            <Container sx={{py: 2}}>
                <Grid container>
                    <Grid item xs={12}>
                        <Paper sx={{p: 2}}>
                            <Box>
                                {testStatus === TEST_STATE.CHECKING && (
                                    <Typography
                                        component='h3'
                                        sx={{
                                        textAlign: 'center',
                                        fontSize: '3rem',
                                        my: 5,
                                        }}
                                    >
                                        Проверка...
                                    </Typography>
                                )}
                                {testStatus === TEST_STATE.IN_PROGRESS && (
                                    <QuestionComponent
                                        question={attestation.lastSubmission.questions[answers.length]}
                                        //@ts-expect-error
                                        answers={answers}
                                        total={attestation.lastSubmission.questions.length}
                                        currentIdx={answers.length}
                                        //@ts-expect-error
                                        onSubmitAnswer={answer => setAnswers([...answers, answer])}
                                    />
                                )}
                                {testStatus === TEST_STATE.SUCCESS && (
                                    <SuccessComponent />
                                )}
                                {testStatus === TEST_STATE.FAIL && (
                                    //@ts-expect-error
                                    <FailComponent testSubmition={attestation.lastSubmission} setTestStatus={setTestStatus} hideRetryMsg={true}/>
                                )}
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </>
    )
};

//@ts-ignore
const mapStateToProps = (state) => { 
    return {
    }
}

//@ts-expect-error
const dispatchProps = (dispatch) => ({
    fetchSubmition: bindActionCreators(actions.fetchAttestationSubmition, dispatch),
    sensAttestationResults: bindActionCreators(actions.sendAttestationResults, dispatch),
})

export default connect(mapStateToProps, dispatchProps)(View);